{
  "auth": {
    "title": {
      "start": "Login to SENS",
      "code": "Enter the verification code",
      "eula": "Before we start, read the users agreement"
    },
    "moto": {
      "start": "Enter your email to login or register",
      "code": "We have sent you code"
    },
    "placeholder": {
      "email": "Enter the email",
      "code": "Enter 6 digit code"
    },
    "btn": {
      "start": "Confirm",
      "code": "Enter",
      "eula": "Accept",
      "confirm": "I am over 18 years old",
      "leave": "Leave the site"
    },
    "text": {
      "start": "I certify that I am over 18",
      "code": "we have sent the code to email <b>{{email}}</b>",
      "eula": "I agree with users agreement",
      "warning": "This site may contain adult content. To continue, please confirm that you are over 18 years of age"
    },
    "countdown": {
      "code": "New code can be requested after",
      "request": "You can request another",
      "btn": "email-code"
    }
  },
  "menu": {
    "title": "Menu",
    "nav": {
      "feed": "Feed",
      "faps": "Faps",
      "profile": "Profile",
      "following": "My following",
      "followers": "My followers",
      "money": "Money",
      "language": "Language",
      "help": "Help",
      "logout": "Log out",
      "confirm": "Confirm profile",
      "author": "Become an author",
      "stream": "Stream",
      "messages": "Messages",
      "promo": "Promo codes",
      "documents": "Documents"
    },
    "top": {
      "create": "Create new post",
      "balance": "Up balance",
      "signIn": "Sign In"
    },
    "links": [
      {"title": "About us"},
      {"title": "Terms of use"},
      {"title": "Privacy policy"},
      {"title": "Agreement between user and author"},
      {"title": "AML and KYC policy"},
      {"title": "Promotions and bonuses policy"},
      {"title": "Community guidelines"},
      {"title": "Report illegal activity"},
      {"title": "Author rules and allowed content"}
    ]

  },
  "pages": {
    "aboutus": {
      "text1": "Type of activities: Sens is a social network that connects creators and audiences, allowing to earn from exclusive content.",
      "list": [
        {
          "text": "Entertaining and erotic content;"
        },
        {
          "text": "Personal subscriptions, paid content in private messages and tips;"
        },
        {
          "text": "Payment by bank card and cryptocurrencies."
        }
      ],
      "contacts": {
        "email": {
          "text": "Email",
          "value": "official@sens.love "
        },
        "phone": {
          "text": "Phone number",
          "value": "+7 (495) 374-71-52"
        }
      }
    }
  },
  "subscription": {
    "basic": {
      "info": {
        "title": "SENS BASIC",
        "text": "Unlock basic content from models with SENS BASIC",
        "text1": "Now available to you",
        "list": [
          {
            "title": "Juicy content from Sens models",
            "text": "Get access to 18+ content published daily"
          },
          {
            "title": "Access to basic content from content creators",
            "text": "Basic posts published by models"
          }
        ],
        "action": {
          "text": "Subscribe to SENS BASIC"
        }
      },
      "success": {
        "title": "Success",
        "text": "Thank you for subscribing to SENS BASIC! Enjoy access to exclusive content from our models.",
        "action": {
          "text": "Start Watching"
        }
      },
      "failure": {
        "title": "Fail",
        "text": "We couldn't process your subscription. Please check your payment details or try again later.",
        "action": {
          "text": "Retry Subscription"
        }
      }
    }
  },
  "common": {
    "Language": "English",
    "locale": "en",
    "Test": "TestENG",
    "Sign in": "Sign in",
    "Today": "Today",
    "Yesterday": "Yesterday",
    "Year ago": "One year ago",
    "Not necessary": "Not necessary",
    "Cancel": "Cancel",
    "OK": "OK",
    "social": {
      "E-mail": "E-mail",
      "Telegram": "Telegram"
    },
    "Continue": "Continue",
    "more": "more",
    "less": "show less",
    "views": "views",
    "goBack": "Go back",
    "save": "Save",
    "Date": "Date",
    "buttons": {
      "Messages": "Messages",
      "Donate": "Donate"
    }
  },
  "error": {
    "value_error.phone_number": "The number is invalid, check again",
    "verification_code.limit": "Too many attempts. Please try again in 60s",
    "verification_code.invalid": "Invalid code",
    "authorization.phonenumber_ban": "We can’t register your account because it was previously deleted for violating our Community Guidelines.",
    "authorization.account_deleted": "Your account was deleted. Please contact support",
    "country.forbidden": "Sens is not working in this country yet",
    "value_error.phonenumber":  "The number is not valid, please, check again",
    "verification_code.request_limit_reached": "Too many requests from you! Try again after 24 hours",
    "verification_code.lifetime": "Too many attempts. Please try again in 5 minutes",
    "captcha.verification_failed": "Your attempt to enter failed. Try again in an hour!",
    "captcha.limit": "Enough time has not passed for a new login attempt",
    "oops": "Something wrong",
    "page": {
      "notFound": {
        "title": "Page not found",
        "text": "The page is out of date, deleted or does not exist at all"
      },
      "forbidden": {
        "title": "The page is not available",
        "text": "Access to the page is limited"
      },
      "broken": {
        "title": "The page is not working",
        "text": "The <b>sens.love</b> site cannot yet process this request"
      }
    },
    "promocode": {
      "not_found": "Promo code not found"
    }
  },
  "validation":  {
    "required": "Required field",
    "greaterThanOrEqualTo": "Must be greater than or equal to {{val}}",
    "lessThanOrEqualTo": "Must be less than or equal to {{val}}",
    "user_name required": "Oops, the nickname can't be empty",
    "minLength": "Field must contain at least {{min}} symbols",
    "user_name minLength": "Nickname must contain at least {{min}} symbols",
    "username should be greater than X charters": "Nickname must contain at least {{min}} symbols",
    "maxLength": "Field can be up to {{max}} symbols",
    "username should be smaller than X charters": "Nicknames can be up to {{max}} symbols",
    "pattern": "Field contains invalid characters",
    "user_name pattern": "Invalid nickname",
    "user_name contains invalid characters": "Invalid nickname",
    "user_name already in use": "Someone was faster: there is already a user with that nickname"
  },
  "search": {
    "Title": "Search",
    "Placeholder": "Search user",
    "Validation": "At least 3 characters",
    "Empty Search": "We didn't find this user",
    "Top": "Top authors",
    "Results": "Search results"
  },
  "user":  {
    "followings": "followings",
    "followers": "followers",
    "Expired": "Expired",
    "Expires": "Expires",
    "Posts": "Posts",
    "Photos": "Photos",
    "Videos": "Videos",
    "Tariffs": "Tariffs",
    "Balance": "Balance",
    "Top up balance": "Top up balance",
    "Followers": "Followers",
    "Followings": "Followings",
    "Publishes": "Publishes",
    "MyProfile": "My profile",
    "My posts": "My posts",
    "Authors posts": "Author's posts",
    "Author": "Author",
    "Subscription terms": "Subscription terms",
    "Full access to author content": "Full access to author's content",
    "Subscription tariff": "Subscription tariff",
    "Subscription payments are made in cryptocurrency": "*Subscription payments are made in cryptocurrency",
    "bonusBalance": {
      "title": "Bonus balance",
      "info": "Can be used to pay for subscriptions and internal purchases"
    },
    "Month": "month",
    "1 Month": "1 month",
    "3 Months": "3 months",
    "tariffs": {
      "t0": "Off",
      "t1": "1 day",
      "t3": "3 days",
      "t5": "5 days",
      "t7": "7 days"
    },
    "Is better": "Is better",
    "Pay subscription": "Pay subscription",
    "Up balance": "Up balance",
    "To edit the tariff, click on one of them": "To edit the tariff, click on one of them",
    "excluding commission": "excluding commission",
    "Minimum withdrawal amount": "Minimum withdrawal amount",
    "Withdraw Funds": "Withdraw Funds",
    "At the moment you have no publications, but you can create a post at any time": "At the moment you have no publications, but you can create a post at any time",
    "Verify your profile to create your first post": "Verify your profile to create your first post",
    "A new identity verification can be started": "A new identity verification can be started",
    "The new check is available": "The new check is available. It will take two minutes of your time",
    "We store your post": "*We store your post for 24 hours: you can publish it as soon as you pass verification",
    "Subscribe": "Subscribe",
    "Resubscribe": "Resubscribe",
    "ValidUntil": "Valid until",
    "Cost": "Cost",
    "Share": "Share link",
    "Share Author": "Share author",
    "Share Post": "Share post",
    "shareProfile": "Share profile",
    "deletePost": "Delete post",
    "Not interesting": "It's not interesting",
    "Complaint": "Complaint",
    "Too many profile verification link requests": "Too many profile verification link requests",
    "Contact our support - we will help you confirm your profile and answer questions": "Contact our support - we will help you confirm your profile and answer questions",
    "our mail": "our mail",
    "our telegram channel": "our telegram channel",
    "and": "and",
    "whyRefuse": "Why did you \n stop watching content?",
    "userFeed": "User feed",
    "sawEverything": "Oops, you saw everything",
    "inBeginning": "In beginning of tape",
    "verification": {
      "title": {
        "start": "Pass verification"
      },
      "description": {
        "start": "You need it to publish your post - it only takes a couple of minutes. All you need is your passport and your photo"
      },
      "confirmProfile": "Verify profile"
    },
    "confirmProfileNow": "Confirm your profile now",
    "through": "through",
    "follow": {
      "successTitle": "Subscription completed successfully!",
      "successMessage": "Now you have full access to the author's content. If you want to renew your subscription, click on the “Renew Subscription” button",
      "OK": "Okay thank you"
    },
    "support": {
      "title": "Is there a problem?",
      "text": "*Choose the most convenient way to communicate"
    },
    "postHidden": "Post Hidden",
    "cancellation": "Cancellation",
    "upload": {
      "description": "In one publication you can upload <span>1 video</span> up to <span>50 megabytes</span> or up to <span>6 photos</span>",
      "continue": "Continue"
    },
    "Photo Area": "Photo Area",
    "comment": "Comment",
    "sendCompliant": "Send Compliant",
    "authorComplaintTitle": "Why did you decide\n to send a complaint against the author?",
    "postComplaintTitle": "Why did you decide to\n post a complaint about the post?",
    "streamComplaintTitle": "Why did you decide\n  send a complaint against a streamer?",
    "fapComplaintTitle": "Why did you decide\n  send a complaint against a faps?",
    "messages": {
      "title": "Messages",
      "chats": "Chats"
    },
    "profile": {
      "editPriceTitle": "Edit subscription price",
      "1monthPrice": "1 month subscription",
      "3monthsPrice": "3 months subscription",
      "editPriceRecommendation": "We do not recommend changing the subscription price more than once every 3 months",
      "profileEditTitle": "Edit profile",
      "changePhoto": "Change photo",
      "userName": "Nickname",
      "personName": "User name",
      "description": "Description",
      "userNameInputPlaceholder": "Enter a nickname",
      "personNameInputPlaceholder": "Enter a name",
      "descriptionInputPlaceholder": "Enter a description",
      "removePhotoConfirmTitle": "Remove photo",
      "removePhotoConfirmMessage": "Are you sure you want to remove the photo?",
      "needToVerify": "You need to verify your profile",
      "needToVerifyNow": "Verify your profile now",
      "confirmProfile": "Confirm profile",
      "newProfileCheck": "New profile check",
      "saveDataButton": "Save data",
      "replaceProfileCover": "Replace profile cover"
    },
    "subscriptions": {
      "Subscriptions": "Subscriptions",
      "subscriptions": "subscriptions",
      "Active": "Active",
      "Completed": "Completed",
      "activeSubscriptions": "Active Subscriptions",
      "completedSubscriptions": "Completed Subscriptions",
      "noSubscriptionsFound": "No subscriptions found",
      "Expires": "Expires",
      "Expired": "Expired",
      "Extend": "Extend",
      "enterYourEmail": "Enter your Email",
      "subscribeMessage": "we will send you a check and also notify you when your subscription ends",
      "editTariff": "Edit tariff",
      "changeSubscriptionPrice": "Change subscription price",
      "minSubscriptionPrice": "minimum subscription price",
      "maxSubscriptionPrice": "maximum subscription price",
      "trialSubscriptionSettings": "Trial subscription settings",
      "maxTrialDays": "maximum number of days",
      "numberOfDaysOfTrialPeriod": "Number of days of trial period"
    },
    "SendMessageButton": "Send message",
    "payment": {
      "nav": {
        "map": "My cards",
        "addMap": "Add card",
        "payments": "Payments"
      },
      "Transactions": "Transactions",
      "paymentSystem": "Payment system",
      "paidAmount": "Amount to be paid",
      "payButton": "Pay",
      "subscriptionValidityPeriod": "Subscription validity period",
      "upTo": "up to",
      "upBalance": "Top up balance",
      "currency": "Currency",
      "paymentMethod": "Payment method",
      "choosePaymentMethod": "Choose payment method",
      "paymentMethodsNotFound": "No payment methods found",
      "conversionRate": "Conversion rate",
      "fee": "Commission",
      "paymentMethodFee": "Payment method fee",
      "serviceFee": "Provider Fee",
      "sum": "Sum",
      "infoMessage": "Please note that the final price may vary due to exchange rates",
      "processingTimeInfoMessage": "Payment processing may take some time",
      "topUp": "Top up",
      "helpLink": "Help with payments",
      "withdrawalOfFunds": "WithdrawalOfFunds",
      "enterWalletAddress": "Enter your wallet address",
      "withdrawFundsButton": "Withdraw funds",
      "transactionHistory": "Transaction History",
      "charges": "Charges",
      "withdrawals": "Withdrawals",
      "noTransactions": "No transactions",
      "operations": "Operations"
    },
    "promocode": {
      "title": "Promo codes",
      "value": "<b>You got:</b> Bonus {{value}}$",
      "basic_subscribe": "<b>You got:</b> basic subscription for {{value}} month",
      "placeholder": "Promo code",
      "action": {
        "check": "Check",
        "apply": "Apply promo code",
        "iHave": "I have a promo code",
        "enter": "Enter promo code"
      },
      "success": {
        "title": "Promo code successfully applied",
        "text": "Bonus balance charged"
      },
      "empty": {
        "title": "Empty for now!",
        "text": "Your promo code history is missing!"
      }
    }
  },
  "stream": {
    "live": {
      "leave": {
        "title": "End stream?",
        "text": "Are you sure?",
        "success": "Complete",
        "decline": "Continue"
      }
    },
    "config": {
      "leave": {
        "title": "leave?",
        "text": "Are you sure?",
        "success": "Close",
        "decline": "Cancel"
      },
      "microphoneVolume": "Microphone volume",
      "microphoneCheck": "Microphone check"
    },
    "bar": {
      "messagesButton": "Messages",
      "donateButton": "Donate",
      "completeLiveButton": "complete LIVE"
    },
    "messages": {
      "title": "Chat"
    },
    "player": {
      "completeMessage": "User ended stream"
    },
    "settings": {
      "title": "LIVE settings",
      "preview": "Preview",
      "startStreamBtn": "Start LIVE"
    },
    "streamIsStarted": "Live broadcast has started!",
    "connectBtn": "Connect"
  },
  "post":  {
    "createPostMessage": {
      "In one publication you can upload": "In one publication you can upload",
      "1 video": "1 video",
      "up to": "up to",
      "50 megabytes": "50 megabytes",
      "or up to": "or up to",
      "6 photos": "6 photos"
    },
    "emptyFeed": {
      "thereWillBeYourMedia": "Your media will go here",
      "verifyYourProfile": "Verify your profile,",
      "toPostContent": "to post content",
      "userDontAddPosts": "The user has not added any posts yet",
      "newPostsWillAppear": "New posts will appear in your feed",
      "subscribeAuthorToViewContent": "Subscribe to the author to view exclusive content",
      "subscribeButton": "Subscribe"
    },
    "passVerification": "Pass verification"
  },
  "onboarding": {
    "step1": {
      "title": "Do you want to become an author and post content? Confirm your profile",
      "message": "This way we can make sure that our authors are real people. It will only take a couple of minutes: as soon as we check everything, you can publish the first video",
      "button": "How to get there?"
    },
    "step2": {
      "title": "Easier than ever",
      "message": "To start checking, allow\n access to the camera and take a photo based on the prompts",
      "button": "What next?"
    },
    "step3": {
      "title": "The rest is also simple",
      "message": "Don't go out: otherwise the scan will be interrupted, and a new one will be available in 2 hours. That's it, the rest is up to us",
      "button": "How long to wait?"
    },
    "step4": {
      "title": "We'll check it in a couple of minutes",
      "message": "As soon as you pass the verification, you will see this message. Your first video will be published immediately",
      "button": "What if I don't pass?"
    },
    "step5": {
      "title": "Can we do it again",
      "message": "This happens: if you fail the test, after 2 hours you can start a new one: we will remind you about this on your profile screen",
      "button": "Start verification"
    },
    "skip": "Skip"
  },
  "media":  {
    "uploadButton": "Upload file",
    "uploadMessage": "It is possible to upload 1 video or up to 6 photos in one post",
    "previewTitle": "Video Preview",
    "newPostTitle": "New Post",
    "descriptionPlaceholder": "Enter a description",
    "requiredFieldMessage": "this field is optional",
    "paidContent": "Paid Content",
    "createPostButton": "Create Post",
    "createFapsButton": "Create Faps",
    "emptyUserPostsMessage": "You don't have any posts at the moment, but you can create a post at any time",
    "notifications": {
      "onlyVideoAndImages": "Only video and images files",
      "sizeLimit": "Not greater than {{limit}} MB"
    }
  },
  "verify": {
    "step1": {
      "title": "Become a content <br/>creator in 2 steps",
      "message1": "Step 1: Upload your document",
      "message2": "Step 2: Take a selfie with the document",
      "buttonVerifyStart": "Start verification",
      "buttonReason": "Why do I need this?",
      "policy": "By starting verification, I agree to the <a target=\"_blank\" href=\"/assets/files/kyc-policy-en.pdf\">KYC policy</a> and <a target=\"_blank\" href=\"/assets/files/privacy-policy-en.pdf\">Privacy Policy</a>"
    },
    "step2": {
      "title": "Verification",
      "message": "Step 1: Upload your document",
      "documentCountry": "Document issuing country",
      "rules": {
        "title": "Verification requirements:",
        "documentType": "Document type: driver's license, national passport, international passport",
        "age": "Age: at least 18 years old",
        "photo": "All uploaded files must be in jpg, png, or jpeg format. File size should not exceed 7 MB"
      },
      "buttonCreatePhoto": "Take a photo",
      "buttonLoadPhoto": "Load from gallery",
      "buttonLookExample": "See example"
    },
    "step3": {
      "title": "Verification",
      "message1": "Step 2: Scan the QR code",
      "message1_mob": "Step 2: Take a selfie with the document",
      "message2": "To complete the verification,\nscan the QR code",
      "message3": "and submit the documents for confirmation",
      "documentCountry": "Document issuing country",
      "rules": {
        "description": "Do not close the window until you switch to a mobile device. The QR code is valid for 2 hours, then the progress resets",
        "title": "Photo requirements:",
        "face": "Face is clearly visible",
        "document": "Photo clearly showing the document",
        "photo": "All uploaded files must be in jpg, png, or jpeg format. File size should not exceed 7 MB"
      },
      "buttonCreatePhoto": "Take a photo",
      "buttonSendPhoto": "Send for review",
      "mobileDevice": "Continue on your mobile \u2028device",
      "successUploadText": "Photo successfully uploaded!",
      "successUploadTextDesc": "You look amazing \uD83D\uDE09"
    },
    "step4": {
      "title": "Review",
      "thanks": "Thank you, for choosing SENS",
      "message1": "We are currently reviewing your account",
      "message2": "This may take from 24 to 48 hours. You will be notified with a message on the page when the review is completed",
      "message3": "After that, you can set the subscription price and start posting your unique content"
    },
    "documentsExample": {
      "passportExample": "An example of a photo of a national/foreign passport",
      "driverLicenseExampleFront": "Fig 1. Front side of a driver's license",
      "driverLicenseExampleBack": "Fig 2. The back side of a driver's license",
      "idExampleFront": "Fig 1. Front side of the ID card",
      "idExampleBack": "Fig 2. Back side of the ID card"
    },
    "buttons": {
      "nextStep": "Next",
      "close": "Close",
      "goBackToVerification": "Back to verification"
    },
    "notifications": {
      "onlyImages": "Only images",
      "documentsUploadedSuccessfully": "Documents uploaded successfully",
      "sizeLimit": "Not greater than {{limit}} MB"
    }
  }
}

